export const RECEPCION_VEHICULO_REQUEST = {
  inputValue: {
    Agreed: false,
    AnomalyList: [],
    Appointment: null,
    AppointmentHeaderID: null,
    AppointmentVehicle: null,
    AssessmentType: 0,
    AuthorizationNumber: null,
    Bail: null,
    BilledDate: null,
    BudgetCode: 0,
    BudgetDate: null,
    BudgetDueDate: null,
    BudgetFinishedDate: null,
    BudgetPrefix: null,
    BudgetRepairOrder: null,
    CLIENTCODE: null,
    COMPANYCODE: null,
    CalculatedLastWarehouseMovementDate: null,
    CalculatedTotalMaterialAmount: 0,
    Chassis: null,
    Checked: false,
    CitOpb: null,
    Company: null,
    ContactEmail: null,
    ContactPhoneNumber: null,
    ControlsList: [],
    CounterSale: null,
    CounterSaleAmendment: null,
    CreatedUserCode: null,
    CreatedUserName: null,
    CustomerAddress: null,
    CustomerCap: null,
    CustomerCaregory: null,
    CustomerCategory: null,
    CustomerCity: null,
    CustomerCode: null,
    CustomerCompany: null,
    CustomerCourtesy: null,
    CustomerEmail: null,
    CustomerFiscalCode: null,
    CustomerIdentificationType: null,
    CustomerIdentificationTypeCode: null,
    CustomerIsoCode: null,
    CustomerName1: null,
    CustomerPrivacy: null,
    CustomerProvince: null,
    CustomerSearchClientCode: null,
    CustomerTelephoneHome: null,
    CustomerTelephoneOffice: null,
    DailyCloseDate: null,
    DeliveryNoteDate: null,
    DeliveryNoteNumber: 0,
    DeliveryNotePrefix: null,
    Destination: null,
    DestinationDescription: null,
    DetailDiscountAmount: 0,
    DetailGrossAmount: 0,
    DiscountPrice: 0,
    DocumentDate: null,
    DocumentDiscount: 0,
    DocumentNotPaid: 0,
    DocumentNumber: 0,
    DocumentPaid: 0,
    DocumentPrefix: null,
    DocumentReopened: null,
    DocumentSubtotals: [],
    DocumentSubtotalsDetails: [],
    DocumentTotal: 0,
    DocumentType: null,
    ExportedSaftDate: null,
    ExpressDelivery: null,
    File: null,
    FinancialInsert: false,
    FrRepairOrderResidueList: [],
    GuaranteeDate: null,
    GuaranteeExtCode: null,
    InternalDepartament: null,
    InternalEmployee: null,
    InternalEmployeeCode: null,
    InvoiceNumber: null,
    InvoiceSaleHeaderList: [],
    IsCounterSaleCash: false,
    IsExportedSaft: null,
    IsoCode: null,
    Km: null,
    LastUpdateDate: null,
    LoadFromOtherCompany: false,
    LocCarroceria: null,
    LocMecanica: null,
    Lock: null,
    MODiscount: 0,
    MaterialDiscount: 0,
    MaterialOrganization: null,
    MatriculationDate: null,
    ModelCode: null,
    ModelDescription: null,
    MovementCode: null,
    MovementWareHouseCode: null,
    Notes: null,
    NotesServicePad: null,
    OrderType: null,
    OrganizationNumber: null,
    OtherCompany: null,
    PaymentCode: null,
    PaymentMode: null,
    PaymentType: null,
    PeuOrigin: null,
    PeuOrigine: null,
    PeuType: null,
    Plate: null,
    PlusDate: null,
    PlusKM: 0,
    Postage: null,
    PostageVatPercentage: 0,
    PreviewedDeliveryDate: null,
    PtRepairOrder: null,
    Receptionist: null,
    ReceptionistCode: null,
    ReferenceNumberUC: null,
    RegistrationDate: null,
    RenderedMaterial: false,
    RepairData: null,
    PRODUCTIONDATA: null,
    RepairNumber: null,
    RepairOrderForfaitList: [],
    RepairOrderLaborList: [],
    RepairOrderMaterialCostList: [],
    RepairOrderMaterialEcotaxList: [],
    RepairOrderMaterialList: [],
    RepairOrderMediaFileList: [],
    RepairOrderOtherMaterialList: [],
    RepairOrderOutsourcingList: [],
    RepairOrderType: null,
    RepairOrderVariousList: [],
    RepairPrefix: null,
    RepairType: 'C',
    RepairerCode: null,
    ReservedType: null,
    SaleDate: null,
    Sales: null,
    Samoa: null,
    ServiceFuelLevel: null,
    ServiceInstructionCustomer: null,
    ServiceInternalMark: null,
    ServiceNumber: null,
    ServiceSpareWheel: false,
    ServiceStation01: null,
    ServiceStation02: null,
    ServiceStation03: null,
    ServiceStation04: null,
    ServiceStation05: null,
    ServiceStation06: null,
    ServiceStation07: null,
    ServiceStation08: null,
    ServiceStation09: null,
    ServiceStation10: null,
    Source: null,
    SpecialDiscount: 0,
    StateCode: null,
    StockUCNumber: null,
    StockUCYear: null,
    TelephonePortable: null,
    ThirdPart: null,
    ThirdParty: null,
    TotalEcotaxAmount: 0,
    TotalForfaitsAmount: 0,
    TotalForfaitsCost: 0,
    TotalLaborAmount: 0,
    TotalLaborCost: 0,
    TotalMaterialAmount: 0,
    TotalMaterialCost: 0,
    TotalOtherMaterialAmount: 0,
    TotalOtherMaterialCost: 0,
    TotalOutSourcingJobsAmount: 0,
    TotalOutSourcingJobsCost: 0,
    TotalRepairOrderAmount: 0,
    TotalRepairOrderAmountWithDiscountAndPostage: 0,
    TotalRepairOrderCost: 0,
    TotalVariousAmount: 0,
    TotalVariousCost: 0,
    UpdatedUserCode: null,
    UpdatedUserName: null,
    VNPreparation: false,
    VarnishCode: null,
    VatAmount: 0,
    VatBaseAmount: 0,
    VatCode: null,
    VatType: null,
    Vehicle: null,
    VehicleBrand: null,
    VehicleBrandCode: null,
    VehicleModelGarage: null,
    VehicleSaleDate: null,
    VehicleType: null,
    Vendor: null,
    Vin: null,
    WareHouseNumber: 1, //Hay que rellenar WareHouseNumber. ¿De dónde sale?
    WorkLineList: null,
    WorkType: null
  }
}
